import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef } from "react";
import { DateTimeInputFallback } from "./DateTimeInputFallback.js";
import { useTextBasedInput } from "../hooks/useTextBasedInput.js";
import { assertDatetimeString } from "../Types/ControlValues.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toViewClass } from "../../../utils/toViewClass.js";
let _isInputDateTimeLocalSupported = null;
function isInputDateTimeLocalSupported() {
  if (_isInputDateTimeLocalSupported === null) {
    const input = document.createElement("input");
    const value = "a";
    input.setAttribute("type", "datetime-local");
    input.setAttribute("value", value);
    _isInputDateTimeLocalSupported = input.value !== value;
  }
  return _isInputDateTimeLocalSupported;
}
const InnerDatetimeInput = memo(
  forwardRef((props, ref) => {
    if (props.value) {
      assertDatetimeString(props.value);
    }
    if (props.max) {
      assertDatetimeString(props.max);
    }
    if (props.min) {
      assertDatetimeString(props.min);
    }
    return /* @__PURE__ */ jsx("input", { ref, ...props, type: "datetime-local" });
  })
);
InnerDatetimeInput.displayName = "InnerDatetimeInput";
const DateTimeInput = memo(
  forwardRef(({
    className,
    withTopToolbar,
    ...outerProps
  }, forwardedRef) => {
    const props = useTextBasedInput({
      ...outerProps,
      className: classNames(
        useComponentClassName("text-input"),
        useComponentClassName("datetime-input"),
        toViewClass("withTopToolbar", withTopToolbar),
        className
      )
    }, forwardedRef);
    return isInputDateTimeLocalSupported() ? /* @__PURE__ */ jsx(InnerDatetimeInput, { ...props }) : /* @__PURE__ */ jsx(DateTimeInputFallback, { ...outerProps });
  })
);
DateTimeInput.displayName = "DateTimeInput";
export {
  DateTimeInput
};
//# sourceMappingURL=DateTimeInput.js.map
